<div class="d-flex flex-column h-100">

  <!-- Header -->
  <div class="panel-section-header px-3 pt-2 pb-2 flex-shrink-0">
    <div class="panel-eyebrow mat-font-label-sm text-uppercase fw-semibold mb-1">
      Custom Elements · Results
    </div>
    <div class="d-flex align-items-center gap-1 mb-1">
      <h2 class="mat-font-title-md fw-semibold mb-0">Detection complete</h2>
    </div>
    <p class="mat-font-body-sm mb-0">
      Custom object detection for {{ objectsLabel() }} completed with 0 results.
    </p>
  </div>

  <!-- Body -->
  <div class="overflow-y-auto overflow-x-hidden flex-fill px-3 py-3 d-flex flex-column gap-3">

    <!-- Error banner -->
    <div class="error-card d-flex gap-2 align-items-start p-3"
         role="alert"
         aria-live="assertive">
      <mat-icon class="flex-shrink-0 mat-icon-md">error_outline</mat-icon>
      <div class="mat-font-body-sm">
        <strong>Detection completed with 0 results</strong><br>
        Try adjusting your detection settings — the model ran but found nothing matching above the threshold.
      </div>
    </div>

    <!-- Amber suggestions card -->
    <div class="suggestions-card">
      <div class="d-flex align-items-center gap-2 mb-2">
        <mat-icon class="flex-shrink-0 mat-icon-md">lightbulb</mat-icon>
        <span class="mat-font-title-sm fw-bold">
          Suggestions to improve results
        </span>
      </div>
      <ul class="mb-0 d-flex flex-column gap-1 mat-font-body-sm">
        <li>Refine the detection label</li>
        <li>
          Lower the similarity threshold
        </li>
        <li>Expand the detection area </li>
      </ul>
    </div>

  </div>

  <!-- Footer -->
  <div class="px-3 py-2 flex-shrink-0 d-flex gap-2">
    <button matButton color="primary" type="button" class="flex-fill"
            (click)="detection.setStage('configure')">
        Back to config
    </button>
    <button matButton="filled" type="button" class="flex-fill"
            (click)="detection.setStage('draw')">
        Change area
    </button>
  </div>

</div>
